export const getHeader = (selected, deductions) => {
  const { payrollTypes, jobTypeVal, payItems } = selected;
  const { additionalType, contributionType, deductionType } = deductions;

  const BasicPayGPHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "OVERPAYMENT (BASIC)" },
    { rowSpan: 2, label: "OVERPAYMENT (PERA ADA)" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    // { rowSpan: 2, label: "Email" },
  ];
  const BasicPayGPSubheaders = [
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];
  const BasicPayAPHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "DATE OF ABSENCES" },
    { rowSpan: 2, label: "LEAVE WITHOUT PAY DATES" },
    { rowSpan: 2, label: "DATE OF HALF DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayAPSubheaders = [
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const BasicPayBPHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "DAYS IN A MONTH" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { colSpan: 1, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA/ADA" },
    { rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" },
    { rowSpan: 2, label: "PERA/ADA FOR BACK-PAY" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayBPSubheaders = [
    // "MONTH",
    // "YEAR",
    "DATE",
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const AugmentationPayGPAPHeaders = [
    { rowSpan: 2, label: "#" },
    ...(payItems === "Back-Pay"
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
    { colSpan: 4, label: "PRESENT ASSIGNMENT" },
    {
      colSpan: 3,
      label: "AUGMENTATION(T1, T3, CIA, MCIA, & DIA)",
    },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "AP RATE" },
    ...(payItems === "Back-Pay"
      ? [{ rowSpan: 2, label: "AP RATE FOR BACK-PAY" }]
      : []),
    { colSpan: 5, label: "CURRENT ASSIGNMENT" },
    { colSpan: 5, label: "AIRPORT AUGMENTATION" },
    { rowSpan: 2, label: "EXCESS AIRPORT DUTIES" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { colSpan: 2, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "NET EARNED" },
    { rowSpan: 2, label: "TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET AMOUNT" },
  ];

  const AugmentationPayGPAPSubheaders = [
    ...(payItems === "Back-Pay" ? ["DATE"] : []),
    "Y=24/7 N=7:00-5:30",
    "# of duty for CIA/MCIA/BINOC (Range to 15-19)",
    "ABS",
    "LATES/ UT per minute",
    "NO.OF DUTIES",
    "ABS",
    "LATES/UT per minute",
    "TOTAL DAYS DUTY",
    "PRORATED AP RATE",
    "ABSENCES/LEAVES",
    "LATES/ UT per minute",
    "EARNED CURRENT ASSIGNMENT",
    "AIRPORT AUGMENTATION RATE",
    "AMOUNT EARNED AIRPORT AUGMENTATION",
    "ABSENCES/LEAVES",
    "LATES/ UT per minute",
    "EARNED AIRPORT DUTIES",
    "OVERPAYMENT",
    "FLAG RAISING",
    ...deductionType,
    ...additionalType,
  ];

  const joBPHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "NO.OF DAYS" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    ...(jobTypeVal === "Job Order" && payItems === "Addendum Payroll"
      ? [{ rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" }]
      : []),
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINS TO BE DEDUCTED" },
    ...(jobTypeVal === "Job Order" && payItems === "Addendum Payroll"
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
    { colSpan: 5, label: "DEDUCTIONS BEFORE TAX" },
    { colSpan: 5, label: "WITHHOLDING TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const joBPSubHeaders = [
    ...(jobTypeVal === "Job Order" && payItems === "Addendum Payroll"
      ? ["DATE"]
      : []),
    "ABSENCES DAYS",
    "ABSENCES MINS",
    "OVERPAYMENT",
    "FLAG RAISING",
    "EARNED FOR THE PERIOD",
    "3%",
    "2%",
    "5%",
    "10%",
    "TOTAL TAX",
    ...deductionType,
    ...additionalType,
  ];

  switch (true) {
    case payrollTypes === "BP" && payItems === "General Payroll":
      return [BasicPayGPHeaders, BasicPayGPSubheaders];
    case payrollTypes === "BP" &&
      jobTypeVal !== "Job Order" &&
      payItems === "Addendum Payroll":
      return [BasicPayAPHeaders, BasicPayAPSubheaders];
    case payrollTypes === "BP" && payItems === "Addendum Back-Pay":
      return [BasicPayBPHeaders, BasicPayBPSubheaders];
    case payrollTypes === "AP" &&
      (payItems === "General Payroll" ||
        payItems === "Newly-Hired" ||
        payItems === "Back-Pay"):
      return [AugmentationPayGPAPHeaders, AugmentationPayGPAPSubheaders];
    case payrollTypes === "BP" && jobTypeVal === "Job Order":
      return [joBPHeaders, joBPSubHeaders];
    default:
      return [[], [], []];
  }
};
